import definition from './folders.service';

/**
 * FoldersApi settings
 * @type {{name: string, definition: FoldersApi}}
 */
export default {
    name: 'FoldersApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/folders/index.js